var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fixed-center text-center" },
    [
      _vm._m(0),
      _c("p", { staticClass: "text-faded" }, [
        _vm._v(_vm._s(_vm.$t("forbidden_error_text")))
      ]),
      _c(
        "q-btn",
        {
          staticStyle: { width: "200px" },
          attrs: { color: "secondary" },
          on: {
            click: function($event) {
              _vm.$router.push("/")
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("back")))]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticStyle: { width: "30vw", "max-width": "150px" },
        attrs: { src: require("assets/sad.svg") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }